import {
  Component,
  ElementRef,
  inject,
  OnInit,
  Output,
  EventEmitter,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AutentificacionService } from 'src/app/_services/autentificacion.service';
import { FocusService } from 'src/app/_helpers/focus.service';
import { ValidacionForm } from 'src/app/_helpers/validacion-form.service';
import { SnackBarService } from 'src/app/_helpers/snack-bar.service';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalNotificacionComponent } from 'src/app/admin/shared/modals/modal-notificacion/modal-notificacion.component';
import { ErrorHandlerService } from 'src/app/_helpers/error-handler.service';
import { Common } from 'devextreme-angular';
import { Subject, takeUntil } from 'rxjs';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';

@Component({
  selector: 'app-restablecer-contrasena',
  templateUrl: './restablecer-contrasena.component.html',
  styleUrls: ['./restablecer-contrasena.component.scss'],
  standalone: false,
})
export class RestablecerContrasenaComponent implements OnInit {
  @Output() VolverInicio = new EventEmitter<void>();
  stylingMode: Common.EditorStyle = 'outlined';
  labelMode: Common.LabelMode = 'floating';
  //Variables para realizar el restablecimiento de la contraseña
  restablecerContrasenaForm!: FormGroup;
  //Inyección de servicios necesarios
  private validacionService = inject(ValidacionForm);
  public focusService = inject(FocusService);
  //Servicios para los modales de aviso:
  private snackBarService = inject(SnackBarService);
  private errorHandlerService = inject(ErrorHandlerService);
  private dialogRef = inject(MatDialog);
  private elementRef = inject(ElementRef);
  private responsive = inject(BreakpointObserver);

  esResolucionMovil = !this.responsive.isMatched(Breakpoints.WebLandscape);
  protected enviando = false;
  destroy$ = new Subject<void>();

  constructor(private autentificacionService: AutentificacionService) {}

  //Al iniciar el componente se inicia el formulario
  ngOnInit() {
    this.initForm();

    this.responsive
      .observe([Breakpoints.WebLandscape])
      .pipe(takeUntil(this.destroy$))
      .subscribe((result) => {
        if (result.matches) {
          this.esResolucionMovil = false;
        } else {
          this.esResolucionMovil = true;
        }
      });
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.focusService.focusPrimerCampo(this.elementRef);
    }, 200);
  }

  //Se asocian al formGroup los valores de los formControlName que hay en el formulario
  //y se asignan las validaciones
  initForm() {
    this.restablecerContrasenaForm = new FormGroup({
      // usuario: new FormControl('', [Validators.required]),
      correo: new FormControl('', [Validators.required, Validators.email]),
    });
  }

  //Funcion de envío de formulario sin petición para
  //mostrar el estilo del modal de aviso
  onSubmit() {
    this.validacionService.markFormGroupTouched(this.restablecerContrasenaForm);

    if (this.restablecerContrasenaForm.invalid) {
      return;
    }

    // const nombreUsuario = this.restablecerContrasenaForm.get('usuario')?.value;
    const correo = this.restablecerContrasenaForm.get('correo')?.value;

    this.enviando = true;
    this.autentificacionService
      .solicitarRestablecerContrasenaUsuario(correo)
      .subscribe({
        next: () => {
          this.snackBarService.showSuccess(
            'Se ha enviado un correo para restablecer la contraseña.',
          );
          this.enviando = false;
          this.onVolverAtras();
        },
        error: (error) => {
          this.errorHandlerService.procesarError(
            error,
            'Error al solicitar el restablecimiento de la contraseña.',
          );
          this.enviando = false;
        },
      });
  }

  //Funcion que controla el estado del formulario segun el campo a validar
  getValidacionEstado(
    nombreCampo: string,
    formGroup: FormGroup,
  ): 'valid' | 'invalid' {
    const control = formGroup.get(nombreCampo);
    if (!control) return 'valid';
    if (control.errors && control.errors['serverError']) return 'invalid';
    return this.validacionService.getFieldValidationState(control) || 'invalid';
  }

  onVolverAtras() {
    this.VolverInicio.emit();
  }
}
